import React from 'react'
import PropTypes from 'prop-types'
import {Flex} from '@chakra-ui/react'
import {remCalc} from '../../../../theme/_utils'
import {TextTitle} from '../../text-title'
import ResponsiveImage from '../../../responsive-image'
import CustomLink from '../../../custom-link'
import {safeBuildUrl} from '../../../../utils/contentstack-utils'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const SocialContent = ({styles, appContent, alignment}) => {
    const {buildUrl} = useMultiSite()

    return (
        <>
            <TextTitle
                color={styles.text.color}
                textStyle="body-large"
                weight="700"
                alignment={alignment}
                pb={remCalc(16)}
            >
                {appContent?.title}
            </TextTitle>
            <Flex {...styles.socialIconsContainer} data-testid="app-download-icons">
                {appContent?.app_buttons?.length > 0 &&
                    appContent.app_buttons.map((store) => (
                        <CustomLink
                            key={store.icon?.title}
                            isExternal={store?.isexternalurl}
                            href={
                                store?.isexternalurl
                                    ? store?.app_link?.href
                                    : safeBuildUrl(store?.app_link?.href, buildUrl)
                            }
                        >
                            <ResponsiveImage
                                imagesm={store?.icon?.url}
                                imageProps={styles.socialIconsBorders}
                            />
                        </CustomLink>
                    ))}
            </Flex>
        </>
    )
}

SocialContent.propTypes = {
    styles: PropTypes.object,
    appContent: PropTypes.object,
    alignment: PropTypes.string,
}
export default SocialContent
